import axios, { AxiosResponse } from 'axios'
import { getAppBaseUrl } from './api'

const baseURL = getAppBaseUrl()

export const getQaiModels = (): Promise<AxiosResponse> => {
    return axios.get(`${baseURL}/qai/models`)
}

export const getQaiModelDetail = (agentKey: string): Promise<AxiosResponse> => {
    return axios.get(`${baseURL}/qai/models/${encodeURIComponent(agentKey)}`)
}

export const syncAllQaiModels = (): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/qai/models/sync`)
}

export const syncQaiModelDetail = (agentKey: string): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/qai/models/${encodeURIComponent(agentKey)}/sync`)
}

export const enqueueQaiPersonaEnrichment = (
    agentKey: string,
    replaceExisting = false
): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/qai/persona-enrichment/jobs/enqueue-agent`, {
        agent_key: agentKey,
        replace_existing: replaceExisting
    })
}

export const enqueueAllQaiPersonaEnrichment = (
    replaceExisting = false
): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/qai/persona-enrichment/jobs/enqueue-all`, {
        replace_existing: replaceExisting
    })
}

export const getQaiCaptionResults = (agentKey: string): Promise<AxiosResponse> => {
    return axios.get(`${baseURL}/qai/captions/results/${encodeURIComponent(agentKey)}`)
}

export const enqueueQaiMediaCaption = (
    agentKey: string,
    mediaKey: string
): Promise<AxiosResponse> => {
    return axios.post(`${baseURL}/qai/captions/jobs/enqueue-media`, {
        agent_key: agentKey,
        media_key: mediaKey
    })
}

export default {
    getQaiModels,
    getQaiModelDetail,
    syncAllQaiModels,
    syncQaiModelDetail,
    enqueueQaiPersonaEnrichment,
    enqueueAllQaiPersonaEnrichment,
    getQaiCaptionResults,
    enqueueQaiMediaCaption
}
